import { makeStyles } from 'tss-react/mui';
import { secondaryTeceoFontFamily, teceoBlackListTooltip } from '../../../Theme';

interface DynamicTagStylesProps {
  tagGap: number;
  tooltipContainerClassName: string;
  horizontalAlignment: 'left' | 'center' | 'right';
}

const horizontalAlignmentMap: Record<DynamicTagStylesProps['horizontalAlignment'], string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

export const useDynamicTagStyles = makeStyles<DynamicTagStylesProps>()(
  (theme, { tagGap, tooltipContainerClassName, horizontalAlignment }) => ({
    boxDynamicContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: horizontalAlignmentMap[horizontalAlignment],
      overflow: 'hidden',
      gap: tagGap,
      [`& > .${tooltipContainerClassName}`]: {
        display: 'inline-flex',
      },
    },
    boxTextInside: {
      fontFamily: secondaryTeceoFontFamily,
      backgroundColor: teceoBlackListTooltip,
      borderRadius: 6,
      padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
      fontWeight: 400,
    },
  }),
);
